import { render, staticRenderFns } from "./push-notification-modal.vue?vue&type=template&id=841c7272"
import script from "./push-notification-modal.vue?vue&type=script&lang=js"
export * from "./push-notification-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports